<template>
  <div class="inline-flex items-center gap-2 font-medium" :class="status.textClass">
    <span class="inline-flex h-5 w-5 items-center justify-center" aria-hidden="true">
      <font-awesome-icon
        v-if="status.icon"
        :icon="status.icon"
        :class="status.textClass"
      ></font-awesome-icon>
    </span>
    <span :class="status.textClass">{{ status.label }} {{date }}</span>
  </div>
  <span class="text-green text-orange text-red"></span>
</template>
<script>
import { defineComponent } from "@vue/runtime-core";

const REVIEW_STATES = {
  pending: {
    label: "Pending",
    icon: "exclamation-circle",
    textClass: "text-red",
  },
  additionalinformationrequired: {
    label: "Additional Information Required",
    icon: "info-circle",
    textClass: "text-orange",
  },
  complete: {
    label: "Complete",
    icon: "check-circle",
    textClass: "text-green",
  },
};

export default defineComponent({
  name: "ReviewValue",
  computed: {
    status() {
      const rawValue = this.params.valueFormatted ?? this.params.value ?? "";
      const normalizedValue = String(rawValue).replace(/[^a-z]/gi, "").toLowerCase();

      return (
        REVIEW_STATES[normalizedValue] || {
          label: rawValue,
          icon: null,
          textClass: "text-gray-600",
        }
      );
    },
  date(a,b,c) {
    return this.params.data ? new Date(this.params.data.Date[this.params.colDef.field]).toLocaleDateString() : "";
  }
  },

});
</script>
